import { render } from "./Effect.vue?vue&type=template&id=310fc74b&scoped=true"
const script = {}

import "./Effect.vue?vue&type=style&index=0&id=310fc74b&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-310fc74b"]])

export default __exports__